const LABELS = {
  search_messages: "Searching messages"
};
const humanize = (tool) => {
  const words = tool.replace(/_/g, " ").trim();
  return `${words.charAt(0).toUpperCase()}${words.slice(1)}`;
};
export const toolCallLabel = (tool) => {
  var _a;
  return (_a = LABELS[tool]) != null ? _a : humanize(tool);
};
export const formatDuration = (durationMs) => durationMs < 1e3 ? `${durationMs} ms` : `${(durationMs / 1e3).toFixed(1)} s`;
